// CCPA Form Required Code
jQuery('#ccpa-request-form input[name="claim"]').change(function(){
    var value = jQuery(this).val();
    if (value == 'Resident') {
        jQuery('.show-resident').removeClass('hide'); 
        jQuery('.show-representative').addClass('hide');        
    } else if (value == 'Representative') {
        jQuery('.show-representative').removeClass('hide');        
        jQuery('.show-resident').addClass('hide'); 
    }
});

// Row Line Box - Line Animations
// When the row scrolls into view, we add the play class
// to all line-bottom objects
if (jq(".line-bottom").length > 0) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                const lineBottomElements = entry.target.querySelectorAll('.line-bottom');
                lineBottomElements.forEach(element => {
                    element.classList.add('play');
                });
                observer.unobserve(entry.target);
            }
        });
    });

    const elements = document.querySelectorAll('.row-line-box');
    elements.forEach(element => {
        observer.observe(element);
    });
}

// Region Slider
jq(document).ready(function () {
    let regionSlider =  jq('.region-slider');
    if (regionSlider.length) {
        var regionSliderOptions = document.getElementById('region-slider-options');
        regionSliderOptions = JSON.parse(regionSliderOptions.innerHTML);
        regionSlider.slick(regionSliderOptions);
        
        // This looks for the tab numbers to change
        // to the correct slide
        jq('a[data-slide]').click(function(e) {
            e.preventDefault();
            var slideno = jq(this).data('slide');
            regionSlider.slick('slickGoTo', slideno - 1);
        });
    }
    // Here we add the active class to the nav items
    jq('.nav-tabs .nav-item, .slider-dots a').click(function() {
        // remove active class from all nav items and slider-dots
        jq('.nav-tabs .nav-item, .slider-dots a').removeClass('active');
        // add active class to clicked nav item and corresponding slider-dot
        var slideIndex = jq(this).data('slide');
        jq('.nav-tabs .nav-item[data-slide="' + slideIndex + '"]').addClass('active');
        jq('.slider-dots a[data-slide="' + slideIndex + '"]').addClass('active');
    });
    
    // Here we check the active slide location when using the arrows to adjust the active classes
    jq('.slide-m-prev-2, .slide-m-next-2').click(function() {
        var currentSlide = jq('.region-slider');
        var slideIndex = currentSlide.find('.slick-slide.slick-active').data('slick-index');
        if (jq('.slick-slide.slick-active[data-slick-index="' + slideIndex + '"]').length) {
            var matchingNavItem = jq('.nav-tabs .nav-item[data-slide="' + (slideIndex + 1) + '"]');
            var matchingSliderDot = jq('.slider-dots a[data-slide="' + (slideIndex + 1) + '"]');
            if (matchingNavItem.length && matchingSliderDot.length) {
                jq('.nav-tabs .nav-item.active, .slider-dots a.active').removeClass('active');
                matchingNavItem.addClass('active');
                matchingSliderDot.addClass('active');
            }
        } else {
            jq('.nav-tabs .nav-item, .slider-dots a').removeClass('active');
        }
    });
    
    // Here we check the active slide from the autoplay to adjust the active classes
    jq('.region-slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
        var slideIndex = jq(slick.$slides.get(currentSlide)).data('slick-index');
        var matchingNavItem = jq('.nav-tabs .nav-item[data-slide="' + (slideIndex + 1) + '"]');
        var matchingSliderDot = jq('.slider-dots a[data-slide="' + (slideIndex + 1) + '"]');
        if (matchingNavItem.length && matchingSliderDot.length) {
            jq('.nav-tabs .nav-item.active, .slider-dots a.active').removeClass('active');
            matchingNavItem.addClass('active');
            matchingSliderDot.addClass('active');
        }
    });
    
    // Add button effect
    jq('.btn').not('.no-effect').addClass('has-effect').wrapInner('<span />').append('<span class="effect" />').on('mouseenter', function(e) {
        var parentOffset = jq(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
        jq(this).find('.effect').css({top:relY, left:relX})
    }).on('mouseout', function(e) {
        var parentOffset = jq(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
        jq(this).find('.effect').css({top:relY, left:relX})
    });
});

// Region Slider Vertical
if (jq('.row-region-slider.vertical').length > 0) {
    const mainRegionSlider = document.querySelector('.row-region-slider.vertical .region-slider');
    const slideInners = document.querySelectorAll('.row-region-slider.vertical .region-slider .slide-inner');
    const sliderWrapper = document.querySelector('.row-region-slider.vertical .slider-wrapper');
    const slider = jq('.row-region-slider.vertical .region-slider');
    
    // Set initial heights
    setSliderHeights();
    
    // Update heights on slide change
    slider.on('afterChange', function(event, slick, currentSlide) {
      setSliderHeights(currentSlide);
    });
    
    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      // Disable adaptiveHeight temporarily
      slick.slickSetOption('adaptiveHeight', false, true);
    });
    
    slider.on('afterChange', function(event, slick, currentSlide) {
      // Re-enable adaptiveHeight
      slick.slickSetOption('adaptiveHeight', true, true);
    });
    
    function setSliderHeights(currentSlide = 0) {
      // Get the current slide-inner element
      const slideInner = slideInners[currentSlide];
    
      // Get all content-inner elements inside the current slide-inner
      const contentInners = slideInner.querySelectorAll('.content-inner');
    
      // Calculate the total height of all content-inner elements including margin
      const totalHeight = Array.from(contentInners)
        .map(contentInner => {
          const computedStyle = window.getComputedStyle(contentInner);
          const margin = parseFloat(computedStyle.marginTop) + parseFloat(computedStyle.marginBottom);
          return contentInner.offsetHeight + margin;
        })
        .reduce((accumulator, currentValue) => accumulator + currentValue);
    
      // Set the height of the slide-inner element to the total height of its content
      slideInner.style.height = `${totalHeight}px`;
    
      // Set the height of the slider wrapper and main slider elements to the height of the current slide-inner
      sliderWrapper.style.height = `${totalHeight}px`;
      mainRegionSlider.style.height = `${totalHeight}px`;
    }
}

// Latest News Slider
if (jq('.latest-news-slider').length > 0) {
    jq('.latest-news-slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        variableWidth: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"></button>', 
        appendArrows: '.slider-nav',
        appendDots: '.slider-nav',
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear'
    });
}



// Left Line Animations (Top to bottom)
// When the row scrolls into view, we add the play class
// to all line-left objects
if (jq(".content-wrapper.line-left").length > 0) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                const lineBottomElements = entry.target.querySelectorAll('.content-wrapper.line-left');
                lineBottomElements.forEach(element => {
                    element.classList.add('play');
                });
                observer.unobserve(entry.target);
            }
        });
    });

    const elements = document.querySelectorAll('.line-left-animation');
    elements.forEach(element => {
        observer.observe(element);
    });
}

// Module Timeline - Custom Months
// We grab all of the .point div's and
// set the content based on the data-month 
if (jq(".module-timeline").length > 0) {
    const points = document.querySelectorAll('.point');
    points.forEach(point => {
        const month = point.getAttribute('data-month');
        if (month) {
            point.style.setProperty('--before-content', `"${month}"`);
        }
    });
}

// Wrap article news in div to prevent it from breaking on mobile
jq('.full-news-article table').each(function(){
    jq(this).wrap("<div class='table-wrapper'></div>");
});
// Check the widths of table-wrapper and tables
function check_tables() {
    jq('.table-wrapper').each(function() {
        if (jq(this).find('table').outerWidth() > jq(this).outerWidth()) {
            jq(this).addClass('scroll');
        } else {
            jq(this).removeClass('scroll');
        }
    });
}
check_tables();